
.login /* -page */ {
    /* background-image: url("../img/spmf-login-bg.jpg") !important;
    background-size: 100% 100%;
    width: 100%;
    height: 100% !important;
    padding: 90px !important; */
    background-image: url("../img/spmf-login-bg.jpg") !important;
    background-size: cover;
    /* background-repeat: round; */
    /* height: 100vh !important; */
}

.login-page {
    background-color: transparent !important;
}

.spmf-login-form {
    border-radius: 10px;
    background-color: white;
    padding-left: 40px;
    padding-right: 40px;
    max-height: 470px;
    max-width: 315px;
}

.spmf-login-content {
    /* margin: 0 auto;
    padding: 25px 0 0;
    position: relative;
    text-align: center;
    text-shadow: 0 1px 0 #fff; */
    min-width: auto;
}

.login_content h1::after,
.login_content h1::before {
    background-color: transparent !important;
}

.spmf-login-content h1 {
    color: deepskyblue;
    font-weight: bold;
    font-size: large;
    letter-spacing: normal;
}

.spmf-login-content .logo {
    width: 80px;
    height: auto;
}

.spmf-login-content button.submit {
    background-color: deepskyblue;
    color: white;
    border-color: deepskyblue;
    font-weight: bold;
    font-size: larger;
}

.spmf-login-content input {
    border-radius: 40px !important;
    border-color: deepskyblue !important;
    border-style: solid !important;
    border-width: 2px !important;
}

#lost-password {
    color: red;
    padding-top: 10px;
    padding-bottom: 50px;
}

#lost-password a {
    color: red;
}

#copyright {
    font-size: small;
}

#welcome {
    color: white;
    /* font-weight: bold; */
    position: absolute;
    top: 16vh;
}

#welcome p:nth-child(1) {
    font-size: 22px;
}

#welcome p:nth-child(2) {
    font-size: 46px;
}

#welcome p:nth-child(2) span {
    font-weight:bolder;
}

.links {
    position: relative;
    top: 91px;
}

.links a,
.links span {
    color: white;
    font-weight: bold;
}

.align-right {
    padding-left: 40px;
    padding-right: 40px;
    max-width: 315px;
}

.pull-right img {
    height: 30px;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/css/login.css
// module id = 756
// module chunks = 0